var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"v-lazy-logo",style:({ 'width': _vm.width + 'px'}),attrs:{"src":"https://res.klook.com/image/upload/image_logo_mx7wgd.png","alt":"logoImg"}})}
var staticRenderFns = []

export { render, staticRenderFns }